const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "shop":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "shop",
    reducer: reducer,
};

export default data;